import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as types from 'constants/actionTypes';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';

const SelectInput = ({
    options,
    id,
    name,
    label,
    floatingLabelText,
    onChange,
    hintText,
    className,
    defaultValue,
    propsErrorStyle,
    required,
    disabled
}) => {
    const dispatch = useDispatch();
    // Access Redux state (value and error)
    const { [name]: reduxValue = "", error: formError = {} } = useSelector((state) => state.form) || {};
    const reduxError = formError ? formError[name] : "";

    // Handle the initial value and fallback to defaultValue if Redux value is not set
    const [localValue, setLocalValue] = useState(reduxValue || defaultValue || '');
    const [localError, setLocalError] = useState(reduxError || '');

    // Sync local value with Redux value
    useEffect(() => {
        if (!reduxValue || reduxValue === "") {
            setLocalValue(defaultValue || ""); // Reset local value
            setLocalError(""); // Clear local error
            dispatch({ type: types.FORM_INPUT, value: defaultValue || "", name });
            dispatch({ type: types.FORM_ERROR, name, error: "" }); // Clear Redux error
        } else if (reduxValue !== localValue) {
            setLocalValue(reduxValue);
        }
    }, [reduxValue]);

    // // Sync local error state with Redux error state
    useEffect(() => {
        if (reduxError !== localError) {
            setLocalError(reduxError);
        }
    }, [reduxError]);

    // Validate the input when it changes
    const validate = (value) => {
        if (!value || value === "") {
            const errorMessage = `${label || floatingLabelText || name} is required.`;
            setLocalError(errorMessage);
            dispatch({ type: types.FORM_ERROR, name, error: errorMessage });
            return false;
        }
        setLocalError("");
        dispatch({ type: types.FORM_ERROR, name, error: "" });
        return true;
    };

    // Handle value change
    const handleChange = (event) => {
        const selectedValue = event.target.value;
        setLocalValue(selectedValue);
        dispatch({ type: types.FORM_INPUT, value: selectedValue, name });
        const selectedItem = options.find((item) => item.value === selectedValue);
        if (selectedItem) {
          dispatch({ type: types.FORM_INPUT, value: selectedItem.text, name: `${name}Text` });
        }else{
          validate(selectedValue);
        }
        
        if (onChange) {
            onChange( event.target.value);
        }
    };

    const handleBlur = () => {
        validate(localValue);
    };

    return (
        <div className={`form-group SelectInput ${className || ``}`}>
            <FormControl
                fullWidth
                variant="standard"
                error={required && Boolean(reduxError)}
                id={name}
                name={name}
                disabled={disabled}
            >
                <InputLabel shrink>{label || floatingLabelText || hintText}</InputLabel>
                <Select
                    id={id || "selectType"}
                    value={localValue}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    label={label || floatingLabelText}
                >
                    {options && options.map((option, index) => (
                        <MenuItem key={option.value} value={option.value} id={`optionItem-${index}`}>
                            {option.text}
                        </MenuItem>
                    ))}
                </Select>
                {required && reduxError ? <FormHelperText style={propsErrorStyle || {}}>{reduxError}</FormHelperText> : null}
            </FormControl>
        </div>
    );
};

export default SelectInput;
